export default __webpack_public_path__ + "static/media/11.ec4428a5.png";